var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.1.6@enquire.js/src/index.js
// module id = 176
// module chunks = 1